
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M415.805 106.006C390.811 46.619 328.311 6 256.442 6 137.698 6 90.823 106.006 84.567 159.122l93.75 12.497c0-12.497 12.497-71.869 78.125-71.869 40.618 0 62.499 21.881 71.868 43.747 3.144 6.256 9.369 28.122-6.256 43.747-6.226 6.256-15.625 12.512-28.107 18.753-34.377 18.753-84.38 50.003-84.38 143.753h93.749c0-31.25 9.369-46.875 37.506-62.5 15.625-9.369 34.363-18.753 49.988-34.378 37.506-37.491 46.876-93.75 24.995-146.866zM256.442 381c-34.531 0-62.5 27.954-62.5 62.5s27.969 62.5 62.5 62.5c34.546 0 62.499-27.954 62.499-62.5S290.988 381 256.442 381z"}})])
          )
        }
      }
    